declare global {
    interface Window {
        appconfig: {
            VITE_BEACON_URL?: string;
            VITE_INVESTOR_BASE_URL?: string;
            VITE_USER_API_BASE_URL?:string;
            VITE_FCLT_APP_URL:string;
            VITE_APPLICATION_ID:string;
            VITE_AUCTIONEER?:string
            VITE_APP_NAME?:string
            VITE_ISWIREDTRANSFER?:string;
            VITE_APIM_KEY:string;
            VITE_MSAL_BASE_URL:string;
            VITE_SIGNIN_POLICY:string;
            VITE_SIGNUP_POLICY:string;
            MSAL_CLIENT_ID:string;
            VITE_LANDING_PAGE_URL:string;

        };
    }
}
export const getInvestorApiUrl = () => window.appconfig?.VITE_INVESTOR_BASE_URL;
export const getFcltAppUrl = () => window.appconfig?.VITE_FCLT_APP_URL;
export const getInvestorBeaconUrl = () => window.appconfig?.VITE_BEACON_URL;

export const getInvestorAuctionerUrl = () => window.appconfig?.VITE_AUCTIONEER;
export const getIsWiredTransfer = () => window.appconfig?.VITE_ISWIREDTRANSFER
export const AppconfigName = () => window.appconfig?.VITE_APP_NAME;
export const getUserApiUrl = () => window.appconfig?.VITE_USER_API_BASE_URL;
export const getApplicationId = ()=>window.appconfig?.VITE_APPLICATION_ID;
export const getAPIMKey = (): string => {
    const baseUrl = window.appconfig.VITE_APIM_KEY;
    if (!baseUrl) {
        throw new Error("VITE_ISWIREDTRANSFER is not defined in appconfig");
    }
 
    return baseUrl;
};
export const getMSALBaseUrl = (): string => {
    const baseUrl = window.appconfig.VITE_MSAL_BASE_URL;
    if (!baseUrl) {
        throw new Error("VITE_ISWIREDTRANSFER is not defined in appconfig");
    }
 
    return baseUrl;
};
export const getSigninPolicy = (): string => {
    const baseUrl = window.appconfig.VITE_SIGNIN_POLICY;
    if (!baseUrl) {
        throw new Error("VITE_ISWIREDTRANSFER is not defined in appconfig");
    }
 
    return baseUrl;
};
export const getSignupPolicy = (): string => {
    const baseUrl = window.appconfig.VITE_SIGNUP_POLICY;
    if (!baseUrl) {
        throw new Error("VITE_ISWIREDTRANSFER is not defined in appconfig");
    }
 
    return baseUrl;
};
export const getClientId = (): string => {
    const baseUrl = window.appconfig.MSAL_CLIENT_ID;
    if (!baseUrl) {
        throw new Error("VITE_ISWIREDTRANSFER is not defined in appconfig");
    }
 
    return baseUrl;
};
export const getLandingPageUrl = (): string => {
    const baseUrl = window.appconfig.VITE_LANDING_PAGE_URL;
    if (!baseUrl) {
        throw new Error("VITE_ISWIREDTRANSFER is not defined in appconfig");
    }
 
    return baseUrl;
};